import FlowerJourney from "../assets/images/123-flowers-path.png";

import "../assets/scss/components/_ethical-banner.scss";
import Config from "../Config";
import { Globe } from "./Globe";
import { Image } from "./Image";
import { Slider } from "./Slider";

export const EthicalBanner = () => {
	const { siteName } = Config;
	return (
		<div className="ethical-banner">
			<div className="intro">
				<h2>Our Promise To Protect The Planet</h2>
				<p>
					At {siteName}, we are committed to protecting the planet and our precious pollinators. We are proud
					to be the first online florist to launch a range of letterbox flowers that are sourced from
					Fairtrade farms with an FSC certification. We are also proud to be the first UK online florist to
					introduce fully recyclable packaging for your fresh flowers and gifts.
				</p>

				<div className="globe-container">
					<Globe />
				</div>
			</div>

			<div className="ethical-descriptions">
				<div className="container">
					<Slider
						slides={[
							{
								element: (
									<div className="ethical-description single-use">
										<strong>We've eliminated single-use plastics from our products</strong>
										<p>
											Every product we offer is completely recyclable and compostable. From
											production to dispatch, we've embraced ethical practices to minimize our
											carbon footprint.
										</p>
									</div>
								),
							},
							{
								element: (
									<div className="ethical-description farming">
										<strong>We are committed to fair and ethical farming practices</strong>
										<p>
											In partnership with top-tier flower farms, we undergo rigorous audits to
											guarantee worker rights, ethical production, and sustainability are
											consistently upheld as primary requirements.
										</p>
									</div>
								),
							},
							{
								element: (
									<div className="ethical-description wildflower">
										<strong>We are staunch advocates for the Wildflower campaign</strong>
										<p>
											We take pride in championing efforts to preserve and safeguard some of
											Britain's most endangered small creatures. Through planting wildflowers
											across the UK, we're doing our part to keep our ecosystem vibrant and alive.
										</p>
									</div>
								),
							},
						]}
						slides_per_row={{ base: 1, md: 3 }}
						autoplay={true}
					/>
				</div>
			</div>

			<div className="flower-journey">
				<div className="container">
					<h2>Your Flower Journey</h2>
					<p>
						Traditionally and quite often the journey of your online flowers would go something like this:
						farm to auction, auction to wholesaler, wholesaler to the transport company, transport to
						market, market to the florist, florist to the customer. Which isn't kind to our environment and
						also sounds exhausting for your poor flowers.
					</p>
					<p>
						Our simplified journey means your flowers go from the farm, hand-tied and lovingly arranged by a
						florist and delivered straight to your doorstep. In bud and ready to light up someones day. Easy
						as 123!
					</p>
					<Image src={FlowerJourney} alt="Flower Journey" />
				</div>
			</div>
		</div>
	);
};

export default EthicalBanner;
